<template>
  <div class="grid grid-cols-1 md:grid-cols-2 min-h-screen">
    <div>
      <header class="flex justify-between py-4 px-8">
        <MobiusLogo />
        <router-link
          :to="{
            path: '/v2/auth/register',
            query: $route.query.redirect ? { redirect: $route.query.redirect } : {},
          }"
          class="text-neutral-700"
        >
          ¿Aún no tienes cuenta?
          <span class="font-bold">Crea una</span>
        </router-link>
      </header>
      <div class="px-5 py-8 md:py-14 text-center m-auto max-w-[400px]">
        <LoginForm />
      </div>
    </div>
    <div class="hidden md:block">
      <RegisterBanner />
    </div>
  </div>
</template>

<script>
import LoginForm from "./LoginForm.vue";
import RegisterBanner from "../register/RegisterBanner.vue";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "LoginV2",
  components: { LoginForm, RegisterBanner, MobiusLogo },
};
</script>
